<template>
  <v-flex xs12 justify-center class="pt-4 px-4">
    <v-card class="elevation-2">
      <v-card-title>
        <span class="primary--text">{{
          operationType == "credit" ? "Total Receivable" : "Total Payables"
        }}</span>
        <v-tooltip right>
          <v-icon small color="#ccc" slot="activator" class="pl-2">help</v-icon>
          <span
            >Current and overdue amount that you're yet to{{
              operationType == "credit" ? " receive." : " pay."
            }}</span
          >
        </v-tooltip>
        <span class="pl-4">
          Total unpaid invoices amount:
          <b class="pl-2">{{ inCurrency(currencyCode, invoicesTotal) }}</b>
        </span>
      </v-card-title>

      <v-progress-linear
        class="mt-0"
        :background-color="currentOverdueColor('overdue')"
        :color="currentOverdueColor('current')"
        height="2"
        :value="invoicesValue"
      />

      <v-card-text class="pt-0 pb-2">
        <v-layout class="py-0 pb-3" justify-center>
          <v-flex xs8 px-4 class="text-xs-center">
            <span :style="'color: ' + currentOverdueColor('current') + ';'"
              >CURRENT</span
            >
            <br />
            <span style="color: #333;" class="subheading">{{
              inCurrencyFromId(currencyId, invoicesCurrent)
            }}</span>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex xs8 px-4 class="text-xs-center">
            <span :style="'color: ' + currentOverdueColor('overdue') + ';'"
              >UNPAID INVOICES OVERDUE</span
            >
            <br />
            <span style="color: #333;" class="subheading">{{
              inCurrencyFromId(currencyId, invoicesOverdue)
            }}</span>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex xs8 px-4 class="text-xs-center">
            <span :style="'color: ' + currentOverdueColor('overdue') + ';'"
              >PAID INVOICES REMAININGS</span
            >
            <br />
            <span style="color: #333;" class="subheading">{{
              inCurrency(
                currencyCode,
                companyBalance.bank_reconciliations_remaining
              )
            }}</span>
          </v-flex>
        </v-layout>

        <v-divider />
        <v-list dense two-line ripple class="pt-2">
          <template v-for="(item, index) in sortedInvoices">
            <v-list-tile :key="index" light ripple>
              <v-list-tile-content>
                <v-list-tile-sub-title class="grey--text text--darken-3">{{
                  item.designation
                }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-title>
                  <span :style="'float:right; color: ' + getAmountColor(item)">
                    {{ item.is_credit_note ? "-" : "" }}
                    {{
                      inCurrencyFromId(
                        currencyId,
                        item.amount - item.reconciliated_amount
                      )
                    }}
                  </span>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  <span class="caption">
                    Overdue
                    {{ item.overdueAmount > 0 ? "since:" : "on:" }}
                    {{ item.expected_payment_date | friendlyDate }}
                  </span>
                </v-list-tile-sub-title>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import currency from "../../../mixins/currency.js";
import date from "../../../mixins/date.js";

export default {
  name: "invoicesDashboardArray",
  mixins: [currency, date],
  props: {
    companyBalance: {
      type: Object,
      required: true,
    },
    invoices: {
      type: Array,
      required: true,
    },
    currencyId: {
      type: String,
      required: true,
    },
    operationType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      nbLines: 5,
      displayAllinvoices: false,
      displayAllPayables: false,
    };
  },
  computed: {
    invoicesCurrent() {
      var tot = 0;
      this.invoices.forEach((element) => {
        if (!element.overdue) tot += this.getInvoiceAmount(element);
      });
      return tot.toFixed(2);
    },
    invoicesOverdue() {
      var tot = 0;

      this.invoices.forEach((element) => {
        if (element.overdue) tot += this.getInvoiceAmount(element);
      });
      return tot.toFixed(2);
    },
    invoicesTotal() {
      var tot =
        parseFloat(this.invoicesCurrent) + parseFloat(this.invoicesOverdue);
      return parseFloat(tot).toFixed(2);
    },
    invoicesValue() {
      if (this.invoicesTotal == 0) return 0;
      else return (this.invoicesCurrent / this.invoicesTotal) * 100;
    },
    sortedInvoices() {
      var ret = Object.values(this.invoices).sort(this.entryComparer);
      if (!this.displayAllinvoices) ret = ret.slice(0, this.nbLines);
      return ret;
    },
  },
  methods: {
    getInvoiceAmount(invoice) {
      if (invoice.is_credit_note)
        return -invoice.amount + invoice.reconciliated_amount;
      else return invoice.amount - invoice.reconciliated_amount;
    },
    currentOverdueColor(arg = "-") {
      switch (arg) {
        case "current":
          return "#268ddd";
        case "overdue":
          return "#ff3200";
        default:
          return "#f4f4f4";
      }
    },
    entryComparer(a, b) {
      return this.olderDate(a.olderDueDate, b.olderDueDate) === a.olderDueDate
        ? -1
        : 1;
    },
    getAmountColor(invoice) {
      return invoice.overdue ? "#ff3200" : "#268ddd";
    },
  },
};
</script>

<style>
.v-list__tile__action--stack {
  margin: 0;
  padding: 0;
}
</style>
